<template>
  <div>
    <a-spin :spinning='loading'>
      <!--            <a-card-->
      <!--                :title="$t(I18N_KEY.ORDER + 'orderInfo')"-->
      <!--                type="inner"-->
      <!--                style="margin-top: 24px;">-->
      <!--                <detail-list>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderNo')" label="订单编号">{{ orderInfo.orderNo }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'firstName')" label="first name">{{ orderInfo.firstName }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'middleName')" label="middle name">{{ orderInfo.middleName }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'lastName')" label="last name">{{ orderInfo.lastName }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationAmount')" label="申请金额">{{ '$'+orderInfo.applyAmt }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationDeadline')" label="申请期限">{{ orderInfo.applyDuration && orderInfo.applyDuration + 'Days' }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'submissionTime')" label="提交时间">{{ orderInfo.submitTime }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'approvalStatus')" label="审批状态">-->
      <!--                        <Dict-->
      <!--                            :dict-code="DICT_CODE.ORDER_STATUS"-->
      <!--                            :value="orderInfo.approvalStatus"/>-->
      <!--                    </detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'loanStatus')" label="放款状态">-->
      <!--                        <Dict-->
      <!--                            :dict-code="DICT_CODE.LOAN_STATUS"-->
      <!--                            :value="orderInfo.loanStatus"/>-->
      <!--                    </detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'loanAmount')" label="放款金额" v-if="orderInfo.paymentAmt">{{ '$'+orderInfo.paymentAmt }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'loanTime')" label="放款时间" v-if="orderInfo.paymentTime">{{ orderInfo.paymentTime }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'settlementStatus')" label="结清状态">-->
      <!--                        <Dict-->
      <!--                            :dict-code="DICT_CODE.SETTLE_STATUS"-->
      <!--                            :value="orderInfo.settleStatus"/>-->
      <!--                    </detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'settlementTime')" label="结清时间" v-if="orderInfo.settleTime">{{ orderInfo.settleTime }}</detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'overdueStatus')" label="逾期状态">-->
      <!--                        <Dict-->
      <!--                            :dict-code="DICT_CODE.OVERDUE_STATUS"-->
      <!--                            :value="orderInfo.overdueStatus"/>-->
      <!--                    </detail-list-item>-->
      <!--                    &lt;!&ndash;<detail-list-item :term="$t(I18N_KEY.ORDER + 'loanPurpose')" label="借款用途">&ndash;&gt;-->
      <!--                        &lt;!&ndash;<Dict&ndash;&gt;-->
      <!--                            &lt;!&ndash;:dict-code="DICT_CODE.LOAN_PURPOSE"&ndash;&gt;-->
      <!--                            &lt;!&ndash;:value="orderInfo.loanPurpose"/>&ndash;&gt;-->
      <!--                    &lt;!&ndash;</detail-list-item>&ndash;&gt;-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderType')" label="订单类型">-->
      <!--                        <Dict-->
      <!--                            :dict-code="DICT_CODE.ORDER_TYPE"-->
      <!--                            :value="orderInfo.orderType"/>-->
      <!--                    </detail-list-item>-->
      <!--                    <detail-list-item :term="$t(I18N_KEY.ORDER + 'loanNumber')" label="借款次数">{{ orderInfo.loanCount }}</detail-list-item>-->
      <!--                  <detail-list-item :term="$t(I18N_KEY.ORDER + 'channel')" label="渠道">{{ orderInfo.channel }}</detail-list-item>-->
      <!--                  <detail-list-item :term="$t(I18N_KEY.ORDER + 'productName')" label="产品名称">{{ orderInfo.productName }}</detail-list-item>-->
      <!--                </detail-list>-->
      <!--            </a-card>-->
      <a-card
        :title="$t(I18N_KEY.ORDER + 'orderInfo')"
        type='inner'
        style='margin-top: 24px;'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'productName')">{{ orderInfo.productName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applyAmt')">{{ orderInfo.applyAmt !== undefined ? orderInfo.applyAmt.toFixed(2) : '' }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'submissionTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationDeadline')">{{ orderInfo.applyDuration }}天
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderNo')">{{ orderInfo.orderNo }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderType')"><Dict :dict-code="DICT_CODE.ORDER_TYPE" :value="orderInfo.orderType"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentAmt')">
            {{ orderInfo.paymentAmt !== undefined ? orderInfo.paymentAmt.toFixed(2) : '' }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentTime')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.paymentTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'extendAmoumt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.extendAmoumt !== undefined ? orderInfo.extendAmoumt.toFixed(2) : '' }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'repaymentAmount')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.repaymentAmount !== undefined ? orderInfo.repaymentAmount.toFixed(2) : '' }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settleAmt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.settleAmt !== undefined ? orderInfo.settleAmt.toFixed(2) : '' }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'lateFee')">    {{ orderInfo.lateFee !== undefined ? orderInfo.lateFee.toFixed(2) : '' }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'overdueDayC')">{{ orderInfo.overdueDays }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'reLendingAmount')">{{ orderInfo.loanCount }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'repayPoint')">{{ orderInfo.repayPoint }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payoutId')">{{ orderInfo.payoutId }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'remarks')"  v-if="orderInfo.approvalStatus === 1" >{{ orderInfo.remarks }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerBasicInfo')"
        type='inner'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'names')">{{ basicInfo.names }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'surnames')">{{ basicInfo.surnames }}</detail-list-item>
          <detail-list-item :term="$t('sex')"><Dict :dict-code="DICT_CODE.SEX" :value="basicInfo.sex"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'curp')">{{ basicInfo.curp }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'collectType')">{{ COLLECT_TYPE[bankCardInfo.collectType] }}
          </detail-list-item>
          <detail-list-item :term="$t('birthday')">{{ basicInfo.birthday }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')"><Dict :dict-code="DICT_CODE.REBORROW_FLAG" :value="basicInfo.reborrowFlag"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ basicInfo.createdTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'channel')">{{ basicInfo.channel }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'appSsid')">{{ basicInfo.appSsid }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'age')">{{ basicInfo.age }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'mobile')">{{ basicInfo.mobileNo }}</detail-list-item>
          <detail-list-item :term="$t('email')">{{ basicInfo.email }}</detail-list-item>
          <detail-list-item :term="$t('addressBook')">{{ addressBookSize }}条
            <a-button
              type="link"
              size="small"
              style="margin-left: 8px"
              @click="showAddressBook = true"
            >
              查看通讯录
            </a-button>
          </detail-list-item>
          <a-modal
            title="通讯录详情"
            :visible="showAddressBook"
            :footer="null"
            width="600px"
            @cancel="showAddressBook = false"
            centered
          >
            <a-table
              :columns="AddressBookColumns"
              :data-source="addressBookData"
              :pagination="AddressBookPagination"
              rowKey="linkMobile"
            />
          </a-modal>
        </detail-list>
      </a-card>
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'bankCardInformation')"
        type='inner'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankName')">
            <!--            <Dict :dict-code='DICT_CODE.BANKLISTF' :value='bankCardInfo.bankAccountName' />-->
            {{ bankCardInfo.bankName }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'cwCode')">{{ bankCardInfo.cwCode }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountName')">{{ bankCardInfo.residentialAddress }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankCardType')"><Dict :dict-code="DICT_CODE.BANK_ACCOUNT_TYPE" :value="bankCardInfo.bankCardType"/></detail-list-item>
        </detail-list>
      </a-card>

      <a-card
        style="margin-top: 24px"
        :title="$t(I18N_KEY.CUSTOMER + 'customerDetailInfo')"
        type="inner">
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'maritalStatus')" ><Dict :dict-code="DICT_CODE.MARITAL_STATUS" :value="detailInfo.maritalStatus"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'numberOfChildren')" >{{detailInfo.numberOfChildren }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'personalMonthlyIncome')"><Dict :dict-code="DICT_CODE.MONTHLY_INCOME" :value="detailInfo.monthlyIncomeScope"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'educationLevel')"><Dict :dict-code="DICT_CODE.EDUCATION" :value="detailInfo.education"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'residentialAddress')" >{{ detailInfo.residentialAddress }}</detail-list-item>
          <!--                              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'residentialAddressPIN')" >{{ detailInfo.residentialAddressPinCode }}</detail-list-item>-->
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'workType')" ><Dict :dict-code="DICT_CODE.WORK_TYPE" :value="detailInfo.workType"/></detail-list-item>
          <!--                             <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'companyName')"  v-if="detailInfo.companyName">{{ detailInfo.companyName }}</detail-list-item>-->
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'workYear')"  v-if="detailInfo.workYears"><Dict :dict-code="DICT_CODE.WORK_YEARS" :value="detailInfo.workYears"/></detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'fb')" >{{ detailInfo.fb }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'line')" >{{ detailInfo.line }}</detail-list-item>
          <!--                             <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payMethod')" label="发薪方式1" v-if="detailInfo.payMethed">{{detailInfo.payMethed}}</detail-list-item>-->
          <!--                             <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payMethod')" label="发薪方式2" v-if="detailInfo.payMethed1">{{detailInfo.payMethed1}}</detail-list-item>-->
          <!--                             <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'workingAddress')" label="工作地址" v-if="detailInfo.workAddress">{{ detailInfo.workAddress }}</detail-list-item>-->
          <!--                             <detail-list-item :term="$t(I18N_KEY.ORDER + 'location')" label="定位地址" v-if="orderInfo.lbs">{{ orderInfo.lbs }}</detail-list-item>-->
        </detail-list>
      </a-card>

      <!--<a-card-->
      <!--style="margin-top: 24px"-->
      <!--:title="$t(I18N_KEY.CUSTOMER + 'customerRiskInfo')"-->
      <!--type="inner">-->
      <!--<detail-list>-->
      <!--<detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCreditScore')">{{ orderInfo.sxCreditScore }}</detail-list-item>-->
      <!--<detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCheatScore')">{{ orderInfo.sxCheatSccore }}</detail-list-item>-->
      <!--</detail-list>-->
      <!--</a-card>-->

      <!--          <a-card-->
      <!--            :title="$t(I18N_KEY.ORDER + 'examineCustomerInfo')"-->
      <!--            type="inner"-->
      <!--            style="margin-top: 24px;">-->
      <!--            <detail-list>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'mobile')">{{ basicInfo.mobileNo }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t('email')">{{ basicInfo.email }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'age')">{{ basicInfo.age }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t('sex')">{{ $t(SEX[basicInfo.sex]) }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'stpAccount')">{{ basicInfo.stpAccount }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'fullName')">{{ basicInfo.fullName }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankName')">{{ bankCardInfo.bankName }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}</detail-list-item>-->
      <!--              <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'residentialAddress')">{{ detailInfo.residentialAddress }}</detail-list-item>-->
      <!--           </detail-list>-->
      <!--          </a-card>-->


      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerLinkInfo')"
        type='inner'>
        <a-table
          :columns='linkColumns'
          :dataSource='linkmanInfos'
          :pagination='false'
          bordered
          ref='table'
          size='middle'
          :rowKey='(record) => record.index'>
<!--          <span slot='contactType' slot-scope='text' :value='text'><Dict :dict-code="DICT_CODE.CONTACT_TYPE" :value="text"/></span>-->
          <Dict slot='contactType' slot-scope='text' :dict-code='DICT_CODE.CONTACT_TYPE' :value='text' />
          <Dict slot='relationType' slot-scope='text' :dict-code='DICT_CODE.RELATIONSHIP' :value='text' />
        </a-table>
      </a-card>
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerImageInfo')"
        type='inner'
        v-viewer='viewOptions'>
        <div v-for='(item, index) in imageInfos' :key='item.imgType'>
          <div class='file-box'>
            <div class='file-item'>
              <p class='file-label'>{{ FILE_TYPE[item.imgType] }}</p>
              <img class='file-preview' :src='item.imgUrl' preview='0'>
            </div>
          </div>
        </div>
      </a-card>
      <a-card
        style='margin-top: 24px;'
        type='inner'>
        <a-tabs v-model='currentTab' @change='onTabChange'>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'repaymentPlan')" key='1'>
            <a-table
              :columns='repayPlanColumns'
              :dataSource='repayPlanSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
              <Dict slot='status' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <template slot='totalAmt' slot-scope='text, record'>
                {{ record.totalAmt !== undefined ? record.totalAmt.toFixed(2) : '' }}
              </template>
              <template slot='lateFee' slot-scope='text, record'>
                {{ record.lateFee !== undefined ? record.lateFee.toFixed(2) : '' }}
              </template>
              <template slot='capital' slot-scope='text, record'>
                {{ record.capital !== undefined ? record.capital.toFixed(2) : '' }}
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'approvalRecord')" key='2' forceRender>
            <a-table
              :columns='examineColumns'
              :dataSource='examineSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
              <Dict slot='approveTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS'
                    :value='text' />
              <Dict slot='approveStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'collectionRecord')" key='3'>
            <a-table
              :columns='collectionColumns'
              :dataSource='collectionSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
              <Dict slot='collectionTaskStatus' slot-scope='text' :dict-code='DICT_CODE.COLLECTION_TASK_STATUS'
                    :value='text' />
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'repaymentRecord')" key='4'>
            <a-table
              :columns='repayRecordColumns'
              :dataSource='repayRecordSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
            </a-table>
          </a-tab-pane>
<!--          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'couponRecord')" key="5">-->
<!--            <a-table-->
<!--              :columns="couponRecordColumns"-->
<!--              :dataSource="couponRecordListSource"-->
<!--              :pagination="false"-->
<!--              bordered-->
<!--              ref="table"-->
<!--              size="middle"-->
<!--              :rowKey="(record) => record.index">-->
<!--            </a-table>-->
<!--          </a-tab-pane>-->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'flowRepayRecord')" key="5">
            <a-table
              :columns="flowRepayColumns"
              :dataSource="repayFlowSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'historicalOrderRecords')" key="6">
            <a-table
              :columns="historicalOrdersColumns"
              :dataSource="historicalOrdersSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
              <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
              <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
              <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'jointBondOrderRecords')" key="7">
            <a-card :bordered="false" style="margin-bottom: 16px">
              <p>逾期订单:{{ orderSummary.overdueTotal }}</p>
              <p>逾期待还金额:{{ orderSummary.overdueMoneySum }}</p>
              <p>未到期订单:{{ orderSummary.notOverdueTotal }}</p>
              <p>未到期待还金额:{{ orderSummary.notOverdueMoneySum }}</p>
              <p>累计已还款金额:{{ orderSummary.amountTotalMoneySum }}</p>
            </a-card>
            <a-table
              :columns="historicalOrdersColumns"
              :dataSource="jointBondOrderSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
              <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
              <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
              <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-spin>

  </div>
</template>
<script>
import { DetailList } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import {   COLLECT_TYPE } from '@/constants/status'
import Dict from '../modules/Dict'
import imageMixin from '@/mixins/image-mixin'
import {getCreditApp} from '@/webpublicapi/customer'
import { getAllOrderListSummary, getPlatformAllOrderList } from '@/webpublicapi/order'

const DetailListItem = DetailList.Item
const I18N_KEY = {
  CUSTOMER: 'customer.',
  ORDER: 'order.'
}

export default {
  props: {
    isQuerySummary: {
      type: [Boolean, Object],
      default: undefined
    },
    orderId: {
      type: [String, Number],
      default: undefined
    },
    custInfoId: {
      type: [String, Number],
      default: undefined
    },
    mobileNo: {
      type: [String, Number],
      default: undefined
    }
  },
  components: {
    DetailList,
    DetailListItem,
    Dict
  },
  mixins: [imageMixin],
  data() {
    return {
      total: 0,
      historicalOrdersSource: [],
      jointBondOrderSource: [],
      orderSummary: {},
      addressBookSize: 0,
      addressBookData: [],
      showAddressBook: false,
      I18N_KEY,
      COLLECT_TYPE,
      loading: true,
      currentTab: '1',
      AddressBookColumns: [
        { title: '姓名', dataIndex: 'linkName', key: 'linkName' },
        { title: '电话', dataIndex: 'linkMobile', key: 'linkMobile' },
      ],
      // 分页配置
      AddressBookPagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: total => `共 ${total} 条数据`,
        onChange: (page) => {
          this.AddressBookPagination.current = page;
        },
        onShowSizeChange: (current, size) => {
          this.AddressBookPagination.pageSize = size;
          this.AddressBookPagination.current = 1;
        }
      },
      linkColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactType'),
          dataIndex: 'contactType',
          key: 'contactType',
          align: 'center',
          scopedSlots: { customRender: 'contactType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactRelationship'),
          dataIndex: 'relationType',
          key: 'relationType',
          align: 'center',
          scopedSlots: { customRender: 'relationType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactName'),
          dataIndex: 'contactName',
          key: 'contactName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactPhone'),
          dataIndex: 'contactPhone',
          key: 'contactPhone',
          align: 'center'
        }
      ],
      FILE_TYPE: {
        'aadhaar_front': this.$t(I18N_KEY.CUSTOMER + 'aadhaarFront'),
        'aadhaar_back': this.$t(I18N_KEY.CUSTOMER + 'aadhaarBack'),
        'pan_front': this.$t(I18N_KEY.CUSTOMER + 'panFront'),
        'face_photo_list': this.$t(I18N_KEY.CUSTOMER + 'facePhotoList'),
        'card_front': this.$t(I18N_KEY.CUSTOMER + 'idcardFront'),
        'card_back': this.$t(I18N_KEY.CUSTOMER + 'idcardNegative')
      },
      repayPlanColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'totalPeriod'),
          dataIndex: 'totalPeriod',
          align: 'center',
          customRender: (text, record, index) => {
            record.index = index
            return text
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'currentPeriod'),
          dataIndex: 'period',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'startingTime'),
          dataIndex: 'beginDate',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'expireTime'),
          dataIndex: 'endDate',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'totalRepayableAmount'),
          dataIndex: 'totalAmt',
          align: 'center',
          scopedSlots: { customRender: 'totalAmt' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'principalPayable'),
          dataIndex: 'capital',
          align: 'center',
          scopedSlots: { customRender: 'capital' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'overdueDays'),
          dataIndex: 'overdueDays',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'forfeitPenalty'),
          dataIndex: 'lateFee',
          align: 'center',
          scopedSlots: { customRender: 'lateFee' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'status'),
          dataIndex: 'status',
          align: 'center'
        }
      ],
      collectionColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionStaff'),
          dataIndex: 'followUserName',
          align: 'center',
          customRender: (text, record, index) => {
            record.index = index
            return text
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionTime'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionTaskStatus'),
          dataIndex: 'collectionTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'collectionTaskStatus' }
        }
      ],
      examineColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStaff'),
          dataIndex: 'examineUserName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTime'),
          dataIndex: 'examineTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTaskStatus'),
          dataIndex: 'approveTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveTaskStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
          dataIndex: 'approveStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalRemark'),
          dataIndex: 'comment',
          align: 'center'
        }
      ],
      repayRecordColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'payOrderNo'),
          dataIndex: 'payOrderNo',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payType'),
          dataIndex: 'payType',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payAmount'),
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payRecipt'),
          dataIndex: 'payRecipt',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'description'),
          dataIndex: 'description',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'errorDescription'),
          dataIndex: 'errorDescription',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'recordTime'),
          dataIndex: 'recordTime',
          align: 'center'
        }
      ],
      couponRecordColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'couponId'),
          dataIndex: 'couponId',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'couponType'),
          dataIndex: 'couponType',
          align:"center",
          customRender: (text) => {
            return  text === "2" ?  '抵扣' : '提额'
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'couponAmount'),
          dataIndex: 'couponAmount',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'validStartDate'),
          dataIndex: 'validStartDate',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'validEndDate'),
          dataIndex: 'validEndDate',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'cpStatus'),
          dataIndex: 'status',
          align:"center",
          customRender: (text) => {
            return  text === "2" ?  '使用' : '创建'
          }
        }
      ],
      flowRepayColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'flowId'),
          dataIndex: 'id',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'channel'),
          dataIndex: 'channel',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payType'),
          dataIndex: 'payType',
          align:"center",
          customRender: (text) => {
            return  text === "00" ?  '正常还款' : '展期还款'
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payLink'),
          dataIndex: 'payLink',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'repayAmount'),
          dataIndex: 'amount',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payinId'),
          dataIndex: 'payinId',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payoutId'),
          dataIndex: 'payoutId',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'repayStatus'),
          dataIndex: 'status',
          align:"center",
          customRender: (text) => {
            return  text === "03"
              ?  '未还款'
              : text === "02"
                ?  '还款失败'
                : text === "01" ? '还款成功':'未知'
          }
        }
      ],
      historicalOrdersColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'custType'),
          align: 'left',
          dataIndex: 'loanCount',
          customRender: (text, row) => {
          if (text > 1) {
            return '老户'
          } else {
            return '新户'
          }
        }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'orderNo'),
            align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
            align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t('customer.names'),
            align: 'left',
          dataIndex: 'names'
        },
        {
          title: this.$t('customer.surnames'),
            align: 'left',
          dataIndex: 'surnames'
        },
        {
          title: this.$t('customer.curp'),
            align: 'left',
          dataIndex: 'curp'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'applicationAmount'),
            align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'loanAmount'),
            align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'productName'),
            align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'loanStatus'),
            align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
            align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'settlementStatus'),
            align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'overdueStatus'),
            align: 'left',
          dataIndex: 'overdueStatus',
          scopedSlots: { customRender: 'overdueStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'applicationTime'),
            align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'expireTime'),
            align: 'left',
          dataIndex: 'endDate'
        }
    ]
    }
  },
  computed: {
    ...mapGetters('order', [
      'orderDetail',
      'repayPlanList',
      'examineLogList',
      'repayRecordList',
      'repayFlowList'
    ]),
    ...mapGetters('operation', [
      'couponRecordList',
    ]),
    ...mapGetters('platformCollection', [
      'allCollectionTaskList'
    ]),
    ...mapGetters('customer', [
      'customerDetail'
    ]),
    basicInfo() {
      return (this.customerDetail && this.customerDetail.basicInfo) || {}
    },
    detailInfo() {
      return (this.customerDetail && this.customerDetail.detailInfo) || {}
    },
    linkmanInfos() {
      return (this.customerDetail && this.customerDetail.linkmanInfos) || []
    },
    aadhaarInfo() {
      return (this.customerDetail && this.customerDetail.aadhaarInfo) || {}
    },
    panInfo() {
      return (this.customerDetail && this.customerDetail.panInfo) || {}
    },
    imageInfos() {
      return (this.customerDetail && this.customerDetail.imageInfos) || []
    },
    bankCardInfo() {
      return (this.customerDetail && this.customerDetail.bankCardInfo) || []
    },
    orderInfo() {
      return (this.orderDetail || {}).orderInfo || {}
    },
    repayPlanSource() {
      return this.repayPlanList || []
    },
    examineSource() {
      return this.examineLogList || []
    },
    repayRecordSource() {
      return this.repayRecordList || []
    },
    repayFlowSource() {
      return this.repayFlowList || []
    },

    collectionSource() {
      return this.allCollectionTaskList || []
    }
  },
  created() {
    this.requestDetail(this.orderId)
  },
  methods: {
    ...mapActions('order', [
      'getOrderDetail',
      'getRepayPlanList',
      'getExamineLogList',
      'getRepayRecordList',
      'getRepayFlowList'

    ]),
    ...mapActions('operation', [
      'getCouponRecordList'
    ]),
    ...mapActions('platformCollection', [
      'getAllCollectionTaskList'
    ]),
    ...mapActions('customer', [
      'getCustomerDetail'
    ]),
    changeTab(tab) {
      this.active = tab
      this.$router.push({
        name: this.$route.name,
        query: {
          tab
        }
      })
    },
    activeTab() {
      this.active = this.$route.query.tab ? this.$route.query.tab : '1'
    },
    onTabChange(key) {
      this.currentTab = key
    },
    requestDetail(id) {
      this.getRepayPlanList({ orderId: id })
      this.getExamineLogList({ orderId: id })
      this.getRepayRecordList({ orderId: id })
      this.getRepayFlowList({ orderId: id })
      this.getAllCollectionTaskList({ orderId: id })
      this.getCouponRecordList({ orderId: id })

      getPlatformAllOrderList({"custInfoId": this.custInfoId,"flag":1}).then((res) => {
        if (res.code === 1000) {
          this.historicalOrdersSource = res.data.rows
        } else {
          this.historicalOrdersSource = []
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message)
      })
      console.log("mobileNo:" + this.mobileNo)
      if(this.mobileNo != null || this.mobileNo !== undefined){
        getAllOrderListSummary({"mobileNo": this.mobileNo}).then((res) => {
          if (res.code === 1000) {
            this.orderSummary = res.data
            this.jointBondOrderSource = res.data.rows
          } else {
            this.jointBondOrderSource = []
            this.$message.error(res.msg)
          }
        }).catch(e => {
          this.$message.error(e.message)
        })

        getCreditApp({custMobile:this.mobileNo}).then((res) => {
          if (res.code === 1000) {
            if(res.data){
              this.addressBookSize = res.data.length
              console.log("res.data.length"+res.data.length)
              this.addressBookData = res.data
            }
          } else {
            console.log('接口异常',res)
          }
        }).catch(e => {
          console.log('调用通讯录接口异常',e.message)
        })

      }


      Promise.all([
        this.getOrderDetail({ id }),
        this.getCustomerDetail({ id: this.custInfoId })
      ]).then(res => {
        this.loading = false
      }).catch(e => {
        this.$message.error(e.message)
        this.loading = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .description-list .content {
  font-weight: 700;
}

.file-box {
  float: left;
  width: 200px;
  height: 200px;
  margin-right: 10px;
  margin: 0 8px 8px 0;

  .file-item {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .file-preview {
      padding: 8px;
      width: 182px;
      height: 142px;
    }

    .file-label {
      margin: 0;
      text-align: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 8px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>